/* ============================================================================
   tne-footer.js — Smooth-scroll dos links anchor do footer.

   Quando alguém clica num link como /#sobre ou #produtos no footer,
   intercepta e faz scroll suave até ao elemento, com offset para o header
   sticky (~80px) para que o título da secção não fique tapado.
   ============================================================================ */

(function () {
  'use strict';

  var HEADER_OFFSET = 80; // px — altura aproximada do header sticky

  var footer = document.querySelector('[data-tne-footer]');
  if (!footer) return;

  // Apenas links internos com anchor (href que contenha "#").
  var anchorLinks = footer.querySelectorAll('a[href*="#"]');

  Array.prototype.forEach.call(anchorLinks, function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href) return;

      // Aceitar "#anchor" ou "/#anchor" mas só quando estamos na home.
      var isInternal = href.charAt(0) === '#' ||
        (href.charAt(0) === '/' && href.indexOf('#') !== -1 &&
         (window.location.pathname === '/' || window.location.pathname === ''));
      if (!isInternal) return;

      var anchorId = href.split('#')[1];
      if (!anchorId) return;

      var target = document.getElementById(anchorId);
      if (!target) return;

      e.preventDefault();

      var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });

      // Atualizar URL sem causar jump.
      if (history.pushState) {
        history.pushState(null, '', '#' + anchorId);
      }
    });
  });
})();
